import Flickity from 'flickity';

export default class BookDemoForm {
  constructor() {
    this.$el = document.querySelector('.js-book-demo-form')
    if (!this.$el) return;

    this.$carousels = this.$el.querySelectorAll('.js-book-demo-form-logo-carousel');

    this.$carousels.forEach($carousel => new Flickity($carousel, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: true,
      autoPlay: 3000,
    }));
  }
}
